var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Schválenie žiadosti")]), _c('button', {
    staticClass: "w-button saveformBtn",
    on: {
      "click": _vm.saveStatus
    }
  }, [_vm._v("Aktualizovať")])]), _c('div', {
    staticClass: "splitter"
  }, [_vm._v("Potvrďte alebo aktualizujte podmienky schválenia")]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "urok"
    }
  }, [_vm._v("Požadovaná sadzba")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.sadzba_pozadovana,
      expression: "formData.sadzba_pozadovana",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "readonly": "readonly",
      "maxlength": "256",
      "min": "1",
      "step": ".01",
      "name": "urok",
      "id": "urok"
    },
    domProps: {
      "value": _vm.formData.sadzba_pozadovana
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "sadzba_pozadovana", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "urok"
    }
  }, [_vm._v("Schválená sadzba")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.sadzba_schvalena,
      expression: "formData.sadzba_schvalena",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "step": ".01",
      "name": "urok",
      "id": "urok"
    },
    domProps: {
      "value": _vm.formData.sadzba_schvalena
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "sadzba_schvalena", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.fix,
      expression: "formData.fix",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "fixacia",
      "id": "fixacia"
    },
    domProps: {
      "value": _vm.formData.fix
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "fix", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_nadobudnutie,
      expression: "formData.suma_nadobudnutie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_nadobudnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_nadobudnutie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_refinancovanie,
      expression: "formData.suma_refinancovanie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_refinancovanie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_refinancovanie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_bezucel,
      expression: "formData.suma_bezucel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_bezucel
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_bezucel", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.splatka,
      expression: "formData.splatka",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "step": ".01",
      "name": "splatka",
      "id": "splatka"
    },
    domProps: {
      "value": _vm.formData.splatka
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "splatka", _vm._n($event.target.value));
      }, function ($event) {
        _vm.paymentManuallyEdited = true;
      }],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "input-hint"
  }, [_vm._v(" Po zmene sumy, sadzby alebo splatnosti sa vypočíta automaticky. Hodnotu môžete upraviť podľa rozhodnutia banky. ")])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.poplatok_za_poskytnutie,
      expression: "formData.poplatok_za_poskytnutie"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "poplatok_za_poskytnutie",
      "id": "poplatok_za_poskytnutie"
    },
    domProps: {
      "value": _vm.formData.poplatok_za_poskytnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "poplatok_za_poskytnutie", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.splatnost,
      expression: "formData.splatnost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "splatnost",
      "id": "splatnost"
    },
    domProps: {
      "value": _vm.formData.splatnost
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "splatnost", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "fixacia"
    }
  }, [_vm._v("Fixácia"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru nadobudnutie"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru refinancovanie"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru bezúčel"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatka"
    }
  }, [_vm._v("Splátka"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost"
    }
  }, [_vm._v("Poplatok"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost"
    }
  }, [_vm._v("Splatnosť"), _c('strong')]);

}]

export { render, staticRenderFns }